import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import {useTranslation} from "react-i18next";
import "../../css/main.css";

export default function DeleteLabelModal({ openDeleteLabelModal, DeleteLabelModalClose, handleDeleteLabel, avoidMisfire, labelIdToDelete }) {
    const { t } = useTranslation();

    return (
        <Dialog open={openDeleteLabelModal} onClose={DeleteLabelModalClose} className="modal-background-color">
            <DialogTitle>{t("modal.warning")}</DialogTitle>
            <DialogContent className="white-txt-color">
                {t("modal.label_delete")}<br />
                {t("modal.label_no_return")}
            </DialogContent>
            <DialogActions>
                <Button onClick={DeleteLabelModalClose} className="button-dark-bg">
                    {t("global.cancel")}
                </Button>
                <Button onClick={() => (handleDeleteLabel(labelIdToDelete))} disabled={avoidMisfire} className="button-dark-bg">
                    {t("modal.delete")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}